import Promise from 'promise'
import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  get () {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/customer')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  getReferrals () {
    return axios.get(LMS_USER_API_URL + '/customer/my-referrals')
  },
  recordOKUdisplay () {
    return axios.post(LMS_USER_API_URL + '/customer/oku-shown')
  },
  sendValidationEmail (index) {
    return axios.post(LMS_USER_API_URL + '/customer/validation-email/' + index)
  },
  sendValidationSMS (index) {
    return axios.post(LMS_USER_API_URL + '/customer/validation-sms/' + index)
  },
  checkValidationSMS (code) {
    return axios.get(LMS_USER_API_URL + '/customer/validation-sms/' + code)
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/customer-resource.js